var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 417.841,
    height: 258.854,
    viewBox: "0 0 417.841 258.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_2486"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0561b1",
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2486-2",
    "data-name": "Path 2486",
    d: "M7368.644,16460.148s21.742-85.136,116.246-28.723,97.082-47.733,133.165-60.751,66.361,61.806,126.224,12.488c23.406-19.283,35.691-38.585,42.077-55.692.315-.844-.047-1.951,0-3.118.086-1.858.026-4.342,0-7.763-.056-7.484.184-18.362,0-29.467-.625-37.705-3.019-85.828-3.019-85.828l-414.692,23.772Z",
    transform: "translate(-7368.644 -16201.295)",
    fill: "#0476d9"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_2486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2486-3",
    "data-name": "Path 2486",
    d: "M7368.644,16460.148s21.742-85.136,116.246-28.723,97.082-47.733,133.165-60.751,66.361,61.806,126.224,12.488c23.406-19.283,35.691-38.585,42.077-55.692.315-.844-.047-1.951,0-3.118.086-1.858.026-4.342,0-7.763-.056-7.484.184-18.362,0-29.467-.625-37.705-3.019-85.828-3.019-85.828l-414.692,23.772Z",
    transform: "translate(-7368.64 -16201.29)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileBanner);
export default __webpack_public_path__ + "static/media/mobile_banner.b9b1fe7cd863f10bca70a9326fda7695.svg";
export { ForwardRef as ReactComponent };